import React from "react";
import Hero from "../components/Hero";
import GrowthJourney from "../components/GrowthJourney";
import WhyChooseUs from "../components/WhyChooseUs";
import Subjects from "../components/Subjects";
import Faculty from "../components/Faculty";
import Testimonials from "../components/Testimonials";
import EnrollmentForm from "../components/EnrollmentForm";
import Footer from "../components/Footer";
import SectionReveal from "../components/SectionReveal";

export default function LandingPage() {
  return (
    <main className="relative" style={{ background: "var(--bg-primary)" }}>
      <SectionReveal>
        <Hero />
      </SectionReveal>
      <SectionReveal>
        <Subjects />
      </SectionReveal>
      <SectionReveal>
        <WhyChooseUs />
      </SectionReveal>
      <SectionReveal>
        <Faculty />
      </SectionReveal>
      <GrowthJourney />
      <SectionReveal>
        <Testimonials />
      </SectionReveal>
      <SectionReveal>
        <EnrollmentForm />
      </SectionReveal>
      <SectionReveal>
        <Footer />
      </SectionReveal>
      <a
        className="whatsapp-fab"
        href="https://wa.me/917012708655"
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <img src="/images/svg/whatsapp-color-svgrepo-com.svg" alt="" aria-hidden="true" />
      </a>
    </main>
  );
}
